import { Dialog, DialogContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colors } from '../../../../theme/colors';
import spacing from '../../../../theme/spacing';
import { fontSize } from '../../../../theme/typography';
import { FaCheckLightSvgIcon } from '../../../../assets/icons/svgs';
import { simpleModalPaperDynamicSizeRootStyles } from '../../../../components/Modals/styles/simpleModalStyles';

interface LanguageSelectionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onLanguageSelect: (languageCode: string) => void;
  currentLanguageCode: string;
}

const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'lt', label: 'Lietuvių' },
];

const LanguageSelectionDialog = ({
  isOpen,
  onClose,
  onLanguageSelect,
  currentLanguageCode,
}: LanguageSelectionDialogProps) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        style: simpleModalPaperDynamicSizeRootStyles,
      }}
    >
      <DialogContent style={{ padding: 0 }}>
        {SUPPORTED_LANGUAGES.map((language) => (
          <div
            key={language.code}
            onClick={() => {
              onLanguageSelect(language.code);
              onClose();
            }}
            className="onClickEffect"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: `${spacing.medium} ${spacing.large}`,
              cursor: 'pointer',
              color:
                currentLanguageCode === language.code
                  ? colors.primary
                  : colors.textPrimary,
              fontSize: fontSize.regular + 2,
            }}
          >
            <span>{language.label}</span>
            {currentLanguageCode === language.code && (
              <FaCheckLightSvgIcon
                size={fontSize.xl}
                style={{
                  color: colors.primary,
                  marginLeft: spacing.medium,
                }}
              />
            )}
          </div>
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default LanguageSelectionDialog;
